export default __webpack_public_path__ + "static/media/icon_service_wechat.4a3917f6.svg";